import { render, staticRenderFns } from "./AllExperiments.vue?vue&type=template&id=72a6f90a&scoped=true&"
import script from "./AllExperiments.vue?vue&type=script&lang=js&"
export * from "./AllExperiments.vue?vue&type=script&lang=js&"
import style0 from "./AllExperiments.vue?vue&type=style&index=0&id=72a6f90a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a6f90a",
  null
  
)

export default component.exports